import { Icon, IconOwnProps, SxProps } from "@mui/material";
import { CSSProperties } from "react";

export type CommonIconProps = {
    style?: CSSProperties;
    sx?: Omit<SxProps<IconOwnProps>, 'color' | 'height' | 'width' | 'fontSize'>;
    icon: string;
    color?: string;
    size: number;
    type: 'filled' | 'outlined' | 'round' | 'sharp';
}
export const CommonIcon = ({ style, sx, icon, color, size, type }: CommonIconProps) => {
    const adjustedIcon = icon.replace('-', '_');
    return <Icon
        className={`material-icons-${type}`}
        style={style}
        sx={{
            ...sx,
            color, 
            height: `${size}px`, 
            width: `${size}px`, 
            fontSize: `${size}px`
        }}
    >
        {adjustedIcon}
    </Icon>
}
